// ----
// ref - https://codepen.io/idorenyinudoh/pen/GRjBXER
// ----

const audioPlayer = document.querySelectorAll('.mod-audio');

document.addEventListener('DOMContentLoaded', () => {
  const calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${returnedSeconds}`;
  };

  audioPlayer.forEach((element) => {
    const audioPlayerContainer = element;
    const playIconContainer = element.querySelector('.mod-audio__play');
    const audioElem = element.querySelector('.mod-audio__audio');
    const seekSlider = element.querySelector('.mod-audio__seek-slider');
    const volumeSlider = element.querySelector('.mod-audio__volume-slider-input');
    const volumeButton = element.querySelector('.mod-audio__volume-button');
    const reloadButton = element.querySelector('.mod-audio__reload');
    const durationContainer = element.querySelector('.mod-audio__time-total');
    const currentTimeContainer = element.querySelector('.mod-audio__time-current');
    let raf = null;
    let playState = 'play';
    let muteState = 'unmute';

    const whilePlaying = () => {
      seekSlider.value = Math.floor(audioElem.currentTime);
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      audioPlayerContainer.style.setProperty('--seek-before-width', `${(seekSlider.value / seekSlider.max) * 100}%`);
      raf = requestAnimationFrame(whilePlaying);
    };

    playIconContainer.addEventListener('click', () => {
      if (playState === 'play') {
        audioElem.play();
        playIconContainer.classList.add('is-playing');
        requestAnimationFrame(whilePlaying);
        playState = 'pause';
      } else {
        audioElem.pause();
        playIconContainer.classList.remove('is-playing');
        cancelAnimationFrame(raf);
        playState = 'play';
      }
    });

    volumeButton.addEventListener('click', (button) => {
      if (muteState === 'unmute') {
        audioElem.muted = true;
        button.target.classList.add('is-muted');
        muteState = 'mute';
      } else {
        audioElem.muted = false;
        button.target.classList.remove('is-muted');
        muteState = 'unmute';
      }
    });

    reloadButton.addEventListener('click', () => {
      audioElem.load();
      audioElem.play();
    });

    const showRangeProgress = (rangeInput) => {
      if (rangeInput === seekSlider)
        audioPlayerContainer.style.setProperty('--seek-before-width', `${(rangeInput.value / rangeInput.max) * 100}%`);
      else
        audioPlayerContainer.style.setProperty(
          '--volume-before-width',
          `${(rangeInput.value / rangeInput.max) * 100}%`,
        );
    };

    seekSlider.addEventListener('input', (e) => {
      showRangeProgress(e.target);
    });

    volumeSlider.addEventListener('input', (e) => {
      showRangeProgress(e.target);
    });

    const displayDuration = () => {
      durationContainer.textContent = calculateTime(audioElem.duration);
    };

    const setSliderMax = () => {
      seekSlider.max = Math.floor(audioElem.duration);
    };

    const displayBufferedAmount = () => {
      if (audioElem.buffered.length) {
        const bufferedAmount = Math.floor(audioElem.buffered.end(audioElem.buffered.length - 1));
        audioPlayerContainer.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.max) * 100}%`);
      }
    };

    const audioFunctions = () => {
      displayBufferedAmount();
      displayDuration();
      setSliderMax();
    };

    if (audioElem.readyState > 0) {
      audioFunctions();
    } else {
      audioElem.addEventListener('loadedmetadata', () => {
        audioFunctions();
      });
    }

    audioElem.addEventListener('progress', displayBufferedAmount);

    seekSlider.addEventListener('input', () => {
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      if (!audioElem.paused) {
        cancelAnimationFrame(raf);
      }
    });

    seekSlider.addEventListener('change', () => {
      audioElem.currentTime = seekSlider.value;
      if (!audioElem.paused) {
        requestAnimationFrame(whilePlaying);
      }
    });

    volumeSlider.addEventListener('input', (e) => {
      const volumeValue = e.target.value;
      audioElem.volume = volumeValue / 100;
      volumeButton.classList.toggle('is-muted', volumeValue <= 0);
    });
  });
});
